/**
 * Выполняет проверки поддержки CSS‑возможностей,
 * которые нельзя проверить через `CSS @supports`.
 * При отсутствии поддержки нужных правил функция помечает элемент `<body>`
 * специальными data‑атрибутами (например, `data-scope-unsupported`),
 * чтобы их можно было использовать в CSS и JS для фолбеков.
 */
export const checkCSSRules = () => {
    // Проверяем поддерживается ли CSS правило @scope
    if (typeof window.CSSScopeRule === 'undefined') {
        document.body.dataset.scopeUnsupported = '';
    }
};
